import {
  CriterionChecklist,
  EvidenceCardConfig,
} from "@risalabs_frontend_org/oasis-ui-kit";
import React from "react";
import { MedicalQuestion } from "../../../data-model/medicalQuestion";

interface MultiCorrectQuestionProps {
  question: MedicalQuestion;
  stepNumber: number | string;
  checkedValues: string[];
  onCheckChange: (value: string, checked: boolean) => void;
  evidenceCards?: EvidenceCardConfig[];
  children?: React.ReactNode;
}

const MultiCorrectQuestion = (props: MultiCorrectQuestionProps) => {
  const { question, stepNumber, checkedValues, onCheckChange, evidenceCards } =
    props;

  return (
    <CriterionChecklist
      key={question.id}
      id={question.id}
      stepNumber={stepNumber}
      title={question.question}
      checklistName={question.id}
      checklistOptions={question.options.map((opt) => ({
        label: opt.text,
        value: opt.id,
      }))}
      checkedValues={checkedValues}
      onCheckChange={onCheckChange}
      evidenceCards={evidenceCards}
      collapsible
      defaultExpanded
    >
      {props.children}
    </CriterionChecklist>
  );
};

export default MultiCorrectQuestion;
